import { useTranslation } from "react-i18next";

interface Props {
  form: ("W" | "D" | "L")[];
}

const COLOR_BY_RESULT: Record<"W" | "D" | "L", string> = {
  W: "var(--color-success)",
  D: "var(--color-warning)",
  L: "var(--color-danger)",
};

const LABEL_KEY_BY_RESULT: Record<"W" | "D" | "L", string> = {
  W: "syndicate.result.win",
  D: "syndicate.result.draw",
  L: "syndicate.result.loss",
};

/**
 * A row of small W/D/L chips — the Syndicate pot card's form strip. A different concept from
 * FormBar (a numeric-score sparkline): this renders discrete match results, not point totals.
 */
export default function WdlChips({ form }: Props) {
  const { t } = useTranslation();

  return (
    <span style={{ display: "flex", gap: 4 }}>
      {form.map((result, i) => {
        const color = COLOR_BY_RESULT[result];
        return (
          <span
            key={i}
            aria-label={t(LABEL_KEY_BY_RESULT[result]) as string}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 18,
              height: 18,
              borderRadius: 5,
              fontSize: "0.65rem",
              fontWeight: 700,
              color,
              background: `color-mix(in srgb, ${color} 15%, transparent)`,
            }}
          >
            {result}
          </span>
        );
      })}
    </span>
  );
}
